/* eslint-disable no-unused-vars */
import React from "react";
import {
  Grid,
  Typography,
  FormControl,
  Autocomplete,
  TextField,
  Alert,
} from "@mui/material";
import { ICarrier } from "../../interfaces/configuration";
import { IAlert } from "../../interfaces/alert";
import GenericAlert from "../GenericAlert";


interface CarrierSelectionFormProps {
  singleCarrierMode: boolean;
  showOwnFleetInfo?: boolean;
  infoMessage?: string;
  alert: IAlert;
  carriersFilteredAndParsed: ICarrier[];
  selectedCarriers: ICarrier[];
  carriersLength: number;
  onAutoCompleteChange: (
    event: any,
    value: ICarrier | ICarrier[] | null,
    reason: string,
    details?: { option: ICarrier }
  ) => void;
}

const CarrierSelectionForm: React.FC<CarrierSelectionFormProps> = ({
  singleCarrierMode,
  showOwnFleetInfo,
  infoMessage,
  alert,
  carriersFilteredAndParsed,
  selectedCarriers,
  carriersLength,
  onAutoCompleteChange,
}) => {
  return (
    <>
      <Typography className="f-s-24">
        Seleccionar operadores logísticos
      </Typography>
      <Grid
        item
        xs={12}
        display="flex"
        flexDirection="column"
        className="m-t-20 m-b-50"
      >
        <Typography className="f-s-14">
          {singleCarrierMode
            ? "Seleccioná tu operador logístico. Podés cargar las credenciales ahora o hacerlo más tarde en la sección de configuración."
            : "Elige los operadores logísticos con los que deseas trabajar. Al terminar este proceso podrás añadir otros en la sección de configuración."}
        </Typography>
        {showOwnFleetInfo && singleCarrierMode && (
          <Alert severity="info" sx={{ mt: 2, mb: 2 }}>
            {infoMessage}
          </Alert>
        )}
        {alert.showAlert && <GenericAlert alert={alert} />}
        <FormControl size="small" className="m-t-20">
          <Autocomplete
            size="small"
            multiple={!singleCarrierMode}
            limitTags={3}
            options={carriersFilteredAndParsed}
            noOptionsText="No se encontró el operador logístico."
            value={singleCarrierMode ? selectedCarriers[0] : selectedCarriers}
            disabled={!carriersLength}
            getOptionLabel={(carrier) => carrier.name || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label={`Seleccionar operador${singleCarrierMode ? "" : "es"}`}
              />
            )}
            onChange={onAutoCompleteChange}
          />
        </FormControl>
      </Grid>
    </>
  );
};

export default CarrierSelectionForm;
